<template>
  <v-container class="grey lighten-5 mt-5" xs="12" v-if="validNews == true">
    <ReportDialog ref="reportDialog"></ReportDialog>
    <CommentDialog ref="commentDialog"></CommentDialog>

    <!--Dialog when share button is clicked-->
    <v-dialog v-model="shareDialog" max-width="600px" class="ma-0">
      <v-card>
        <v-row class="ma-0 pa-0 exitShare">
          <v-btn icon @click="shareDialog = false">
            <v-icon small>fas fa-times</v-icon>
          </v-btn>
        </v-row>

        <v-list>
          <v-list-item>
            <v-text-field
              class="ma-5 pa-5"
              readonly
              color="primary"
              v-model="shareURL"
              ref="getShareURL"
              type="text"
              auto-grow
              single-line
              full-width
            >
              <template v-slot:append>
                <v-btn tile color="primary" text class="ma-0" @click="copy">copy</v-btn>
              </template>
            </v-text-field>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col
            class="cardCol"
            v-for="card in articles"
            :key="card.id"
            cols="6"
            lg="4"
            md="4"
            sm="6"
            xs="6"
          >
            <v-card class="pa-1 ma-0 noBorder d-flex flex-column" outlined flat tile height="100%">
              <v-card-actions class="pa-0 ma-0">
                <v-card-text justify="start" class="pa-2">
                  <span class="authorText pa-0">{{card.NickName}}</span> |
                  <span
                    class="dateText"
                    :style="$vuetify.breakpoint.smAndDown?'display:block':''"
                  >{{card.Date}}</span>
                </v-card-text>

                <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="cardIcon" v-bind="attrs" v-on="on">
                      <v-icon small>fas fa-ellipsis-h</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="bookmark()">
                      <v-list-item-title>
                        <v-btn icon class="cardIcon">
                          <v-icon small>far fa-bookmark</v-icon>
                        </v-btn>
                        {{$t("Bookmark article")}}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click.stop="
                $refs.reportDialog.openDialog({
                  reportedId: card.id,
                  reportType: 'article',
                  content: card.Title
                })
              "
                    >
                      <v-list-item-title>
                        <v-btn icon class="cardIcon">
                          <v-icon small>fas fa-exclamation-triangle</v-icon>
                        </v-btn>
                        {{$t("Report")}}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="share(card.id)">
                      <v-list-item-title>
                        <v-btn icon small class="cardIcon">
                          <v-icon small>fas fa-share-alt</v-icon>
                        </v-btn>
                        {{$t("Share")}}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-actions>

              <v-card
                class="noBorder"
                outlined
                flat
                tile
                :to="{
                name: `frontpage`,
                params: { articleid: card.id },
              }"
              >
                <v-img
                  v-if="card.MediaData && card.MediaData.length > 0"
                  :src="`${card.MediaData[0]['s3url']}-web.jpg`"
                  class="middleCatimg"
                  cover
                />
                <v-img v-else :src="`/lrVxWoHA.png`" class="middleCatimg" contain />

                <v-row class="pa-0 ma-0">
                  <v-col class="tagChipCol" :cols="12">
                    <v-chip
                      v-for="tag in card.categories"
                      :key="tag.id"
                      class="tagChip"
                      text-color="white"
                      color="indigo"
                      small
                    >#{{tag.category}}</v-chip>
                  </v-col>
                </v-row>

                <h2
                  class="pa-2 middleCardTitle"
                  style="display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical; overflow: hidden;"
                >{{card.Title}}</h2>
                <div
                  class="subtitles"
                  style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                  v-html="card.Content"
                />
              </v-card>

              <v-spacer></v-spacer>
              <v-card-actions class="pa-0 align-end" justify="center" align="center">
                <v-col>
                  <v-btn icon small class="cardIcon">
                    <v-icon small>fas fa-book-reader</v-icon>
                    <span class="metaCount">{{card.Views}}</span>
                  </v-btn>
                </v-col>

                <v-col>
                  <v-btn
                    icon
                    small
                    class="cardIcon"
                    @click.stop="
                        $refs.commentDialog.openDialog({
                          Content: '',
                          Articles_id: card.id,
                          ArticleComments_id: card.id
                        })
                      "
                  >
                    <v-icon small>far fa-comment-alt</v-icon>
                    <span class="metaCount">{{card.Comments}}</span>
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/*
How this script works:

1. FrontPageLayout.vue sends all remaining articles to store.js (remainingNews list)
2. Whenever remainingNews is updated in store, the getRemainingNews Watch function here triggers change
3. update() looks at remainingNews and parses content before visualizing it (adding metatags, correct date
    format etc.) We load 12 articles in the beginning, the rest is inserted in a buffer
4. If the user scrolls at the bottom, check if we have remaining data in the buffer and then load that too
*/

import { mapGetters, mapActions } from "vuex";
import messages from "../../modules/lang/main/export";
import ReportDialog from "@/components/dialogs/report_dialog.vue";
import CommentDialog from "@/components/dialogs/kommentar_dialog.vue";
export default {
  i18n: { messages },

  components: {
    ReportDialog,
    CommentDialog,
  },

  data() {
    return {
      articles: [],
      buffer: [], //When user scrolls at the bottom, load from this buffer
      validNews: false, //Activate only if we have enough tech news (else whole container is hidden)
      shareDialog: false,
      shareURL: window.location.href,
    };
  },

  computed: {
    ...mapGetters(["getRemainingNews"]),
  },

  watch: {
    getRemainingNews(data) {
      //Update cards when tech news is updated
      this.update(data);
    },
  },

  methods: {
    ...mapActions(["parseDate"]),

    async update(news) {
      this.validNews = true;
      this.formatNews(news);
    },

    async formatNews(news) {
      for (const el of news) {
        el.Date = await this.parseDate(el.Updated);

        let categories = [];
        if (news[0].metadata) {
          el.metadata.metatags.forEach((tag) => {
            if (
              categories.filter(function (e) {
                return e.category === tag.category;
              }).length == 0
            ) {
              categories.push(tag);
            }
          });
        }

        if (categories.length == 0) {
          categories = [{ category: "general", id: "1" }];
        }

        el.categories = categories;
      }
      this.articles = news.slice(0, 12);
      this.buffer = news.slice(12, news.length);
    },

    loadBufferedArticles() {
      return new Promise((resolve, reject) => {
        let articleLen = this.articles.length;
        if (!this.buffer.length) {
          //The buffer is empty
          reject();
        } else if (this.buffer.length >= 12) {
          //Add 12 new articles to the frontpage and update buffer
          this.from = this.from + 12;
          this.articles = [...this.articles, ...this.buffer.slice(0, 12)];
          this.buffer = this.buffer.slice(12, this.buffer.length);
          resolve();
        } else {
          //Add all remaining ones and empty buffer
          this.articles = [...this.articles, ...this.buffer];
          this.from = this.articles.length;
          this.buffer = [];
          resolve(); //Empty buffer -> Dont load more
        }
      });
    },
    returnLengthOfBuffer() {
      return this.buffer.length;
    },
    bookmark() {
      //TODO
    },
    share(id) {
      this.shareURL = location.origin + "/api/share/" + id;
      this.shareDialog = true; //Opens share dialog
    },
    copy() {
      let textInput = this.$refs.getShareURL.$el.querySelector("input");
      textInput.select();
      document.execCommand("copy");
    },
  },
};
</script>


<style scoped>
hr.hr1 {
  border: 1px solid black;
}

.subtitles {
  font-size: 1em;
}

.cardIcon {
  margin: 0px 10px 0px 0px;
  opacity: 0.8;
}

.cardIconSmall {
  display: inline-block;
}

.noBorder {
  border: 0 !important;
}

.dateText {
  color: #666;
  font-size: 0.8em;
}

.authorText {
  font-weight: bold;
  font-size: 0.8em;
}

.metaCount {
  color: #ff5252;
  padding-left: 5px;
  font-size: 1.2em;
}

.mainCatimg {
  max-height: 500px !important;
}

.middleCatimg {
  height: 140px !important;
}

.smallCatimg {
  height: 70px !important;
  width: 115px !important;
}

.techCol {
  color: rgb(14, 165, 0) !important;
}

.middleCardTitle {
  font-size: 1.2em;
}

.smallCardTitle {
  font-size: 1em;
  display: inline-block !important;
}

.smallCardSubtitle {
  padding: 0px;
}

.views {
  text-transform: lowercase !important;
  opacity: 1 !important;
  padding-left: px;
}

#shareDialog {
  max-width: 300px !important;
}
.exitShare {
  justify-content: end;
}

.tagChipCol {
  padding: 0px !important;
  max-height: 40px !important;
  overflow: hidden !important;
}

.tagChip {
  margin: 10px 1px 5px 1px !important;
  display: inline-block;
}
@media (max-width: 600px) {
  .cardCol {
    margin: 0px;
    padding: 4px 2px 4px 2px;
  }

  .tagChip {
    font-size: 8px;
    height: 18px;
    padding-left: 6px;
    padding-right: 6px;
  }

  .middleCardTitle {
    font-size: 1em;
  }

  .subtitles {
    font-size: 0.7em;
  }
}
</style>